













import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ProductDetailsTitle',
  props: {
    title: {
      type: String,
      required: true,
      default: 'not-set',
    },
  },
  computed: {
    formatedTitle(): string {
      return `${this.title}`
    },
  },
})
